<template>
  <vue-croppie
    ref="croppieRef"
    :enableOrientation="true"
    :enableResize="false"
    :viewport="{ width: 300, height: 400, type: 'circle' }"
    :boundary="{ width: 600, height: 600 }"
    :maxZoom="4"
  >
  </vue-croppie>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: "",
    },
  },
  watch: {
    src: {
      immediate: true,
      async handler(newValue) {
        if (newValue) {
          if (!this.$refs.croppieRef) {
            await this.$nextTick();
          }
          this.$refs.croppieRef.bind({
            url: this.src,
          });
        }
      },
    },
  },
  methods: {
    getResult() {
      return new Promise((resolve) => {
        return this.$refs.croppieRef.result({ circle: false }, resolve);
      });
    },
  },
};
</script>

<style lang="scss">
.croppie-container {
  height: auto !important;
}
</style>
